import { type FunctionComponent, type ReactNode, useState } from 'react';

import { Checkbox } from '@dr.pogodin/react-utils';

import { MODALITIES, type ModalityT } from 'utils';

import './style.scss';

type PropsT = {
  customModalities: string[];
  label?: string;
  modalities: ModalityT[];
  onChange: (standard: ModalityT[], custom: string[]) => void;
};

// TODO: It would be good to distill a part of this component into
// the more generic (a group of checkboxes) component, as the same stuff
// is used for several more similar UI components, just with different
// options to select.
export const VideoModalities: FunctionComponent<PropsT> = ({
  customModalities,
  label,
  modalities,
  onChange,
}) => {
  const [customModality, setCustomModality] = useState<string>('');

  const modalitySet = new Set(modalities);
  const content: ReactNode[] = [];

  for (const modality of MODALITIES) {
    const checked = modalitySet.has(modality);
    content.push(
      <Checkbox
        checked={checked}
        key={modality}
        label={modality}
        onChange={() => {
          onChange(
            checked
              ? modalities.filter((item) => item !== modality)
              : [...modalities, modality],
            customModalities,
          );
        }}
      />,
    );
  }

  content.push(<div key="separator" styleName="separator" />);

  for (let i = 0; i < customModalities.length; ++i) {
    const modality = customModalities[i];
    if (!modality) throw Error('Missing modality');
    content.push(
      <Checkbox
        checked
        key={`custom/${i}/${modality}`}
        label={modality}
        onChange={() => {
          const newCustomModalities = [...customModalities];
          newCustomModalities.splice(i, 1);
          onChange(modalities, newCustomModalities);
        }}
      />,
    );
  }

  content.push(
    <input
      key="custom-modality-input"
      onChange={(e) => {
        setCustomModality(e.target.value);
      }}
      onKeyDown={(e) => {
        if (customModality && (e.key === 'Enter' || e.key === 'Tab')) {
          if (!customModalities.includes(customModality)) {
            onChange(
              modalities,
              [...customModalities, customModality],
            );
          }
          setCustomModality('');
        }
      }}
      placeholder="Other"
      styleName="plainInput"
      value={customModality}
    />,
  );

  return (
    <div styleName="checkboxGroup">
      <div styleName="checkboxGroupTitle">{label ?? 'Modalities'}</div>
      {content}
    </div>
  );
};
